export const TypeNameBlockInBrief = 'ParagraphBlocBref';
